<script>
    import PageHeadingSection from "../ui/PageHeadingSection.svelte";

</script>
<svelte:head>
	<title>RODO - WW Notariusz</title>
	<meta name="description" content="Informacje o przetwarzaniu RODO kancelarii" />
</svelte:head>

<PageHeadingSection 
	title="RODO - WW Notariusz"
	imageUrl="/rodo.jpg"
/>

<section class="section">
	<div class="container">
		<h2 class="heading">Obowiązek informacyjny RODO</h2>

		<p class="paragraph">
			Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. 
			w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego 
			przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Ogólne Rozporządzenie o Ochronie Danych - RODO), 
			informujemy, że Administratorem Pani/Pana danych osobowych jest Kancelaria Notarialna 
			"KANCELARIA NOTARIALNA AGNIESZKA WENCEL IWONA WRZEŚNIAK" z siedzibą przy ul. Krakowska nr 180 lok. A3, 52-015 Wrocław, 
			posiadająca numer REGON: 525621158 oraz NIP: 8992963822.
		</p>

		<h3>Cel przetwarzania danych osobowych</h3>

		<p class="paragraph">
			Pani/Pana dane osobowe przetwarzane będą w celu realizacji czynności notarialnych, zgodnie z przepisami prawa oraz 
			wypełnienia obowiązków wynikających z Ustawy o notariacie oraz innych przepisów prawa.
		</p>

		<h3>Podstawa prawna przetwarzania danych osobowych</h3>

		<p class="paragraph">
			Podstawą prawną przetwarzania Pani/Pana danych osobowych jest niezbędność przetwarzania do wykonania umowy notarialnej lub 
			podjęcia działań na Pani/Pana żądanie przed zawarciem takiej umowy, a także wypełnienia obowiązków prawnych ciążących na administratorze danych.	
		</p>

		<h3>Odbiorcy danych osobowych</h3>

		<p class="paragraph">
			Pani/Pana dane osobowe mogą być udostępniane: Innym stronom w umowie notarialnej lub ich przedstawicielom, w celu realizacji czynności notarialnych. Organom państwowym lub innym podmiotom, na podstawie przepisów prawa.
		</p>

		<h3>Okres przechowywania danych osobowych</h3>

		<p class="paragraph">
			Pani/Pana dane osobowe będą przechowywane przez okres niezbędny do celów, dla których zostały zebrane, z uwzględnieniem przepisów prawa, które mogą wymagać dłuższego okresu przechowywania.
		</p>

		<h3>Prawa związane z przetwarzaniem danych osobowych</h3>
		<p class="paragraph">
			Zgodnie z RODO, przysługują Pani/Panu następujące prawa związane z przetwarzaniem danych osobowych: Prawo dostępu do danych osobowych.
		</p>
		
		<ul>
			<li>Prawo do przenoszenia danych osobowych.</li>
			<li>Prawo do ograniczenia przetwarzania danych osobowych.		</li>
			<li>Prawo do sprostowania danych osobowych.		</li>
			<li>Prawo do usunięcia danych osobowych.		</li>
			<li>Prawo do wniesienia sprzeciwu wobec przetwarzania danych osobowych.		</li>
		</ul>

		<p class="paragraph">W celu skorzystania z tych praw, prosimy o kontakt z nami pod adresem podanym powyżej.</p>

		<h3>Skargi do organu nadzorczego	</h3>

		<p class="paragraph">
			Jeśli uważa Pani/Pan, że przetwarzanie Pani/Pana danych osobowych narusza przepisy RODO, ma Pani/Pan prawo złożyć skargę do organu nadzorczego ds. ochrony danych osobowych.
		</p>

		<h3>Skargi do organu nadzorczego	</h3>

		<p class="paragraph">
			Podanie danych osobowych jest dobrowolne, ale niezbędne do zawarcia umowy notarialnej lub wykonania działań na Pani/Pana żądanie przed zawarciem takiej umowy.
		</p>
	</div>
</section>